import { Component, Input } from '@angular/core';
import { CheckboxFilterLocalizationsModel } from '../../models/checkbox-filter-localizations.model';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';

@Component({
    selector: 'agpr-checkbox-filter',
    templateUrl: './checkbox-filter.component.html',
    styleUrls: ['./checkbox-filter.component.scss'],
    providers: [getProvider(CheckboxFilterComponent)],
    standalone: false
})
export class CheckboxFilterComponent extends ControlValueAccessorModel<any[]> {
    public readonly buttonTypes = ButtonTypesEnum;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('Localization') localization: CheckboxFilterLocalizationsModel = new CheckboxFilterLocalizationsModel();
    @Input() labelField = 'name';
    @Input() valueField = 'id';
    @Input() includeSelectAll: boolean = true;
    @Input() options: any[] = [];

    /**
     * Unchecks all available options
     */
    public uncheckAll() {
        this.value = [];
        this.onModelChange(this.value);
    }

    /**
     * Checks all available options
     */
    public checkAll() {
        this.value = this.options.slice();
        this.onModelChange(this.value);
    }

    writeValue(value: any[]): void {
        this.value = [];
        if (!value)  {
            return;
        }

        this.value = this.options.filter(optionItem => this.optionIsInValue(optionItem, value));
    }

    optionIsInValue(option: any, value: any[]) {
        return !!value.find(valueItem => valueItem[this.valueField]  === option[this.valueField]);
    }
}
